import React, { Component } from 'react';
import * as moduleAction from '../action/moduleAction';
import AppStore from '../store/appStore';
import LayoutLoader from '../component/LayoutLoader/LayoutLoader';

export const withModuleCheck = (module, initModuleAction) => (WrappedComponent) => {

  class WithModuleCheck extends Component {

    constructor(props) {
      super(props);
      this.state = {};
    }

    componentWillMount() {
      AppStore.addChangeListener(this.onChange);
      AppStore.addChangeLangListener(this.onLangChange);
      moduleAction.setCurrentModule(module);
    }

    componentWillUnmount(){
      AppStore.removeChangeListener(this.onChange);
      AppStore.removeChangeLangListener(this.onLangChange);
    }

    componentDidMount() {
      initModuleAction();
    }

    render() {
      const { isReady } = this.state;

      return (
        <section>
          <WrappedComponent {...this.props} display-if={isReady} />
          <LayoutLoader display-if={!isReady} />
        </section>
      )
    }

    onChange = () => {
      window.setTimeout(() => {
        this.setState({
          isReady: AppStore.isModuleReady()
        });
      })
    };
  
    onLangChange = () => {
      window.setTimeout(() => {
        initModuleAction();
      })
    };
  }

  return WithModuleCheck;
};
